import { Component, ViewEncapsulation, ɵConsole, OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { RestWS } from 'app/services/restService';
import { UtilityProvider } from 'app/providers/utility/utility';
import { fuseAnimations } from '@fuse/animations';
import { GlobalService } from 'app/services/globalService';
import { CryptProvider } from 'app/providers/crypt/crypt';



import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { pl } from 'date-fns/locale';
import { compileInjectable } from '@angular/compiler';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';


@Component({
    selector: 'pricing-style-1',
    templateUrl: './style-1.component.html',
    styleUrls: ['./style-1.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PricingStyle1Component implements OnInit {
    cliente: any;
    cargado: boolean = false;
    planes: any;
    plans: any;
    planCliente = {
        planId: '',
        nombre: '',
        numeroFirmas: 0,
        comentario: '',
        fechaRenovacion: new Date(Date.now()),
        firmados: '',
        precio: 0
    };
    datos: any;

    registerForm: FormGroup;
    codigo: string;
    planActual: any;

    loading: boolean = false;
    mostrarCard: boolean = false;

    constructor(
        private translationLoader: FuseTranslationLoaderService,
        private api: RestWS,
        private utils: UtilityProvider,
        private _formBuilder: FormBuilder,
        private globalService: GlobalService,
        private router: Router,
        private crypto: CryptProvider

    ) {


        this.registerForm = this._formBuilder.group({

            month: ['', Validators.required],
            year: ['', Validators.required],
            number: ['', Validators.required],
            cvc: ['', Validators.required]

        });



    }
    ngOnInit(): void {
        // this.translationLoader.loadTranslations(english, spanish);
        this.cliente = this.globalService.cliente;

        
        if (!this.cliente) {
            //Si no hay cliente, debemos leer las cookies
            this.globalService.leerCookies().then(res => {

                // Si devuelve falso es porque no tenemos la sesión iniciada, o no tenemos acceso a esta sección.
                // Por lo que redirigimos a la pantalla de login.
                if (!res) {
                    this.router.navigateByUrl("/pages/auth/login");
                } else {
                    this.cliente = this.globalService.cliente;
                    this.inicializa();
                }
            });
        } else {
            //console.log("this.cliente", this.cliente);
            //Si hay cliente, continuamos
            this.inicializa();

        }

    }

    inicializa() {
        //console.log(this.cliente.tarjetaPago.numero)
        if (!this.cliente.tarjetaPago.numero) {
            this.cliente.tarjetaPago = this.crypto.decryptData(this.cliente.tarjetaPago, 'smart2020pay');
            if (!this.cliente.tarjetaPago.numero) {
                this.cliente.tarjetaPago = {
                    numero: '',
                    mes: '',
                    anyo: '',
                    cvv: ''
                }
            }
        }
        //console.log(this.cliente)
        if (this.cliente.stripe.plan === '') {
            this.cliente.stripe.plan = 'Gratuito1'
        }
        console.log(this.cliente.stripe, this.cliente.tarjetaPago);
        this.api.getPlans().then(async planes => {
            this.plans = planes.message;
            await this.ordenarplanes();
            //console.log(this.plans)
            let datos = await this.datosSubscripcion();
            this.cliente.stripe.plan = datos.plan.planId;
            this.planActual = datos.plan;
            //console.log('plan: ', this.cliente.stripe.plan);
            this.planActual.fechaRenovacion = datos.renovacion;
            this.planActual.firmados = datos.numeroEnventos;
            this.planActual.estado = datos.estado;
            this.cargado = true;

        })
    }

    async ordenarplanes() {
        this.plans.sort(function (a, b) {
            if (a.precio > b.precio) {
              return 1;
            }
            if (a.precio < b.precio) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });
    }

    convertirFecha(inicio) {
        var dateInicio = new Date(inicio * 1000);
        var year = dateInicio.getFullYear().toString();
        var month = (dateInicio.getMonth() + 1).toString();
        var day = dateInicio.getDate().toString();
        var hh = dateInicio.getHours().toString();
        var mm = dateInicio.getMinutes().toString();
        var ss = dateInicio.getSeconds().toString();

        return new Date(year + '-' + month + '-' + day + ' ' + hh + ':' + mm + ':' + ss);

    }

    async datosSubscripcion() {
        let plan = this.plans.filter(p => p.planId === this.cliente.stripe.plan)[0];
        //console.log(plan)
        if (plan.stripe === 0) {
            let numeroEventos = await this.api.getCountEvents(this.cliente._id, '2019-01-01');
            let estado = 'active';
            let limiteExcedido = false
            if (numeroEventos.result >= plan.numeroFirmas) {
                limiteExcedido = true
            }
            return { limite: limiteExcedido, estado: estado, plan: plan, inicio: null, renovacion: null, numeroEnventos: numeroEventos.result }

        } else {
            let subscripcion = await this.api.getSubcription(this.cliente.stripe.subscripcion);
            let fechaInicioSubscripcion = this.convertirFecha(subscripcion.message.current_period_start);
            let fechaRenovacionSubscripcion = this.convertirFecha(subscripcion.message.current_period_end);
            let numeroEventos = await this.api.getCountEvents(this.cliente._id, fechaInicioSubscripcion.toUTCString());
            let plan = this.plans.filter(p => p.planId === subscripcion.message.plan.id)[0];
            let limiteExcedido = false;
            if (numeroEventos.result >= plan.numeroFirmas) {
                limiteExcedido = true;
            }

            let estado = '';
            if (subscripcion.message.status === 'active') estado = 'activo';
            if (subscripcion.message.status === 'canceled') estado = 'cancelado';
            if (subscripcion.message.cancel_at_period_end === true) estado = 'pendiente';


            return { limite: limiteExcedido, estado: estado, plan: plan, inicio: fechaInicioSubscripcion, renovacion: fechaRenovacionSubscripcion, numeroEnventos: numeroEventos.result }
        }
    }

    async confirmaciones(plan) {
        this.confirmarMetodoPago(plan);
    }

    confirmarMetodoPago(plan) {
        if (this.cliente.stripe.card !== '') {
            let next = 'STYLE1.NEXT';
            let importe = (Number(plan.precio - this.planActual.precio) * 1.21).toFixed(2)
            let data = { traducir: true, renovacion: true, importe: importe, boton: true, botontexto: 'STYLE1.CHANGEPAY', textodata: 'STYLE1.PAYTEXT', tarjeta: '**' + this.cliente.tarjetaPago.numero.substr(14), check: true, checked: false }
            let message = plan.nombre.toUpperCase();
            this.utils.openDialog(this.utils.TARJETA, message, true, true, next, data).then(resp => {
                if (resp === true) this.confirmarDireccion(plan)
                if (resp === 'ir') window.location.replace('/#/pages/profile');
            })

        } else {
            this.utils.openDialog(this.utils.WARNING, 'STYLE1.NOPAY', true, true, null, { traducir: true })
                .then(resp => {
                    if (resp === true) {
                        window.location.replace('/#/pages/profile');
                    }
                })

        }
    }

    confirmarDireccion(plan) {

        let data = { boton: true, botontexto: 'STYLE1.FACTURACIONCHANGE', cif: this.cliente.cif, direccion: this.cliente.direccionFacturacion, check: true, checked: false }
        this.utils.openDialog(this.utils.FACTURACION, this.cliente.razonSocial, true, true, 'STYLE1.NEXT', data).then(resp => {
            if (resp === true) this.codigoPromocional(plan)
            if (resp === 'ir') window.location.replace('/#/pages/profile');
        })
    }

    codigoPromocional(plan) {
        
        let codigoCliente = this.utils.getCodigosPromocionales().find( codigo =>  codigo.codigo === this.cliente.codigoPromocional);
        if (codigoCliente) {
            codigoCliente.codigo = codigoCliente.stripe ? codigoCliente.codigo : "";
        } else {
            codigoCliente = {
                codigo: "",
                tarjeta: false,
                stripe: false
            }
        }
        let data = { botontexto: 'STYLE1.NEXT', codigoPromocional: true, codigo: codigoCliente.codigo, traducir: true }
        let message = 'STYLE1.CODE';
        this.utils.openDialog(this.utils.CODIGO, message, false, true, 'STYLE1.NEXT', data).then(resp => {

            //console.log(resp);
            if (resp === '' || !resp) {
                this.codigo = 'ninguno';
                this.confirmarCondiciones(plan)
            } else {
                this.comprobarCodigo(resp, plan)
            }
        })
    }

    comprobarCodigo(codigo, plan) {
        this.api.getCoupons().then(coupons => {
            let cupones = coupons.message.data
            let find = cupones.filter(c => c.name === codigo);

            if (find[0]) {
                this.utils.openDialog(this.utils.WARNING, 'STYLE1.CODEOK', false, true, null, { traducir: true }).then(resp => {
                    this.codigo = find[0].id;
                    this.confirmarCondiciones(plan)
                })

            } else {
                this.utils.openDialog(this.utils.WARNING, 'STYLE1.CODEBAD', false, true, null, { traducir: true }).then(resp => {
                    this.codigoPromocional(plan);
                })
            }
        })
    }

    confirmarCondiciones(plan) {
        //console.log('codigo: ', this.codigo)
        let data = { checked: false, condiciones: true, traducir: true }
        let message = 'STYLE1.TERMS';
        this.utils.openDialog(this.utils.WARNING, message, true, false, 'STYLE1.SUBSCRIBE', data).then(resp => {
            if (resp === true) this.hacer_subscripcion(plan);
        })
    }


    subscribirse(plan) {

        if ((this.cliente.stripe.subscripcion !== '') &&
            (this.planActual.estado !== 'pending') &&
            (this.planActual.estado !== 'cancelado')) {
            let plan_anterior = this.planActual;
            let plan_actual = plan;
            if (Number(plan_actual.precio) > Number(plan_anterior.precio)) {

                this.utils.openDialog(this.utils.WARNING, 'STYLE1.SUPERIOR', true, true, null, { traducir: true }).then(resp => {
                    if (resp === true) {
                        this.confirmarMetodoPago(plan);
                    }
                })
            } else {
                this.utils.openDialog(this.utils.WARNING, 'STYLE1.INFERIOR', false, false, null, { traducir: true });
            }
        } else {
            this.confirmarMetodoPago(plan);
        }
    }


    cancelar_subscripcion(plan) {

        this.utils.openDialog(this.utils.WARNING, 'Va a cancelar su subscripcion al plan ' + plan.nombre.toUpperCase(), true, true).then(async resp => {
            //console.log(resp)

            if (resp === true) {
                this.api.cancelSubscription(this.cliente.stripe.subscripcion).then(subscripcion => {
                    if (subscripcion.status === 'ok') {

                        this.api.editarClienteStripe(this.cliente, 'subscripcion').then(async cliente => {
                            this.utils.openDialog(this.utils.SUCCESS, 'La cancelación se ha realizado con éxito.', false, false)
                            let datos = await this.datosSubscripcion();
                            this.cliente.stripe.plan = datos.plan.planId;
                            this.planActual = datos.plan;
                            //console.log('plan: ', this.cliente.stripe.plan);
                            this.planActual.fechaRenovacion = datos.renovacion;
                            this.planActual.firmados = datos.numeroEnventos;
                            this.planActual.estado = datos.estado;

                        })
                    } else {
                        this.utils.openDialog(this.utils.WARNING, 'La cancelación no ha podido ser efectuada.', false, false)
                    }
                })
            }
        })
    }

    crear_subscripcion(plan) {

        this.api.createSubscription(plan.planId, this.cliente.stripe.customer, this.codigo).then(async subscription => {
            if (subscription.status === 'ok') {
                this.cliente.stripe.plan = plan.planId;
                this.cliente.stripe.subscripcion = subscription.message.id;
                this.planActual = plan;
                this.api.editarClienteStripe(this.cliente, 'subscripcion').then(async cliente => {
                    let datos = await this.datosSubscripcion();
                    this.planActual.fechaRenovacion = datos.renovacion;
                    this.planActual.firmados = datos.numeroEnventos;
                    this.planActual.estado = datos.estado;
                    this.utils.openDialog(this.utils.SUCCESS, 'La subscripción se ha realizado con éxito.', false, false)
                })
            } else {
                this.utils.openDialog(this.utils.ERROR, 'Ha ocurrido un error al subscribirse al producto.', false, false)
            }
        })
    }

    hacer_subscripcion(plan) {

        if ((this.cliente.stripe.subscripcion !== '') &&
            (this.planActual.estado !== 'pending') &&
            (this.planActual.estado !== 'cancelado')) {
            let plan_anterior = this.planActual;
            let plan_actual = plan;
            this.subir_subscripcion(plan_anterior, plan_actual)
        } else {
            this.crear_subscripcion(plan);
        }
    }

    async subir_subscripcion(plan_anterior, plan_actual) {
        await this.update_subscripcion(plan_actual);
    }

    async bajar_subscripcion(plan_anterior, plan_actual) {
        this.api.cancelSubscription(this.cliente.stripe.subscripcion).then(cancelada => {
            if (cancelada.status === 'ok') {
                this.cliente.stripe.plan = "Gratuita1";
                this.planCliente.planId = "Gratuita1";
                this.api.createSubscription(plan_actual.planId, this.cliente.stripe.customer, this.codigo).then(async subscripcion => {
                    if (subscripcion.status === 'ok') {
                        this.cliente.stripe.plan = plan_actual.planId;
                        this.cliente.stripe.subscripcion = subscripcion.message.id;
                        // this.planCliente.planId = plan_actual.planId;
                        // await this.calculaFechasSubscripcion(subscripcion.message);
                        this.api.editarClienteStripe(this.cliente, 'subscripcion').then(async cliente => {
                            let datos = await this.datosSubscripcion();
                            this.planActual = datos.plan;
                            this.planActual.fechaRenovacion = datos.renovacion;
                            this.planActual.firmados = datos.numeroEnventos;
                            this.planActual.estado = datos.estado;

                            this.utils.openDialog(this.utils.SUCCESS, 'El cambio de subscripción se ha realizado con éxito', false, false);


                        })
                    }
                })
            } else {
                this.utils.openDialog(this.utils.ERROR, 'Ha ocurrido un error al cambiar la subscripción del producto.', false, false)
            }
        })
    }

    update_subscripcion(plan) {
        this.api.updateSubscription(plan.planId, this.cliente.stripe.subscripcion, this.codigo).then(async subscription => {
            if (subscription.status === 'ok') {
                this.cliente.stripe.plan = plan.planId;
                this.cliente.stripe.subscripcion = subscription.message.id;
                // await this.calculaFechasSubscripcion(subscription.message);
                this.api.editarClienteStripe(this.cliente, 'subscripcion').then(async cliente => {
                    let datos = await this.datosSubscripcion();
                    this.planActual = datos.plan;
                    this.planActual.fechaRenovacion = datos.renovacion;
                    this.planActual.firmados = datos.numeroEnventos;
                    this.planActual.estado = datos.estado;
                    this.utils.openDialog(this.utils.SUCCESS, 'STYLE1.SUBSCRIBECHANGEOK', false, false, null, { traducir: true })

                }).catch(err => {
                    this.utils.openDialog(this.utils.ERROR, 'STYLE1.SUBSCRIBECHANGEBAD', false, false, null, { traducir: true })
                })
            } else {
                this.utils.openDialog(this.utils.ERROR, 'STYLE1.SUBSCRIBECHANGEBAD', false, false, null, { traducir: true })
            }
        })



    }

    // calculaFechasSubscripcion(subscripcion) {
    //     //console.log(subscripcion);

    //     let inicio = subscripcion.current_period_start;
    //     let renovacion = subscripcion.current_period_end;

    //     var dateInicio = new Date(inicio * 1000);
    //     var year = dateInicio.getFullYear().toString();
    //     var month = (dateInicio.getMonth() + 1).toString();
    //     var day = dateInicio.getDate().toString();
    //     this.cliente.subscripcion.fechaInicio = year + '-' + month + '-' + day

    //     var dateRenovacion = new Date(renovacion * 1000);
    //     var year = dateRenovacion.getFullYear().toString();
    //     var month = (dateRenovacion.getMonth() + 1).toString();
    //     var day = dateRenovacion.getDate().toString();
    //     this.cliente.subscripcion.fechaRenovacion = year + '-' + month + '-' + day

    // }

    hoy(tipo, mfecha) {

        let dias = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        const today = new Date(mfecha);

        let dd = today.getDate().toString();
        let di = today.getDate() - 29;
        let mm = (today.getMonth() + 1).toString();
        let hh = today.getHours().toString();
        let nn = today.getMinutes().toString();
        let ss = today.getSeconds().toString();
        let yyyy: String;


        if (Number(hh) < 10) hh = '0' + hh;
        if (Number(nn) < 10) nn = '0' + nn;

        if (Number(mm) < 10) mm = '0' + mm;
        if (Number(dd) < 10) dd = '0' + dd;

        yyyy = today.getFullYear().toString();

        let fecha = '';

        if (tipo === 0) fecha = yyyy + '-' + mm + '-' + dd; // Fecha formato ingles
        if (tipo === 1) fecha = dd + '-' + mm + '-' + yyyy; // Fecha formato español
        if (tipo === 2) fecha = hh + ':' + nn; // hora formato HH:MM
        if (tipo === 3) fecha = yyyy + mm + dd + hh + nn + ss; // numero resumen
        if (tipo === 4) fecha = yyyy + '-' + mm + '-01';
        if (tipo === 5) fecha = yyyy + '-' + mm + '-' + dias[Number(mm) - 1];

        return fecha;

    }


    aceptar_metodopago(plan) {
        let card = {
            number: this.registerForm.get('number').value,
            month: this.registerForm.get('month').value,
            year: this.registerForm.get('year').value,
            cvc: this.registerForm.get('cvc').value,
        }
        this.api.createPayment(card, this.globalService.cliente.email).then(payment => {
            if (payment.status === 'ok') {
                this.cliente.stripe.card = payment.message.id
                this.api.editarClienteStripe(this.cliente, 'tarjeta').then(cliente => {
                    //console.log(cliente);
                    this.utils.openDialog(this.utils.SUCCESS, 'STYLE1.SUBSCRIBEOK', false, false, null, { traducir: true })
                })
            }
        })
    }

    cancelar_metodopago() {
        this.mostrarCard = false;
    }

}
